// extracted by mini-css-extract-plugin
export default {"modalOverlay":"PB-z","modalContent":"QB-z","header":"RB-z","close":"SB-z"};